<!-- Cabecera -->
<app-header-back-office></app-header-back-office>

<!-- Contenido -->
<router-outlet></router-outlet>